var _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIns2IconCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8316 3.0486C2.27932 3.0486 1.8316 3.49632 1.8316 4.0486V20.3847C1.8316 20.937 2.27932 21.3847 2.8316 21.3847H6.2585C6.81079 21.3847 7.2585 20.937 7.2585 20.3847V4.0486C7.2585 3.49631 6.81079 3.0486 6.2585 3.0486H2.8316ZM5.97476 4.74118H3.08754V19.8685H5.97476V4.74118Z",
    fill: "#6F7687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9303 3.0486C15.378 3.0486 14.9303 3.49632 14.9303 4.0486V20.3847C14.9303 20.937 15.378 21.3847 15.9303 21.3847H19.3572C19.9095 21.3847 20.3572 20.937 20.3572 20.3847V4.0486C20.3572 3.49631 19.9095 3.0486 19.3572 3.0486H15.9303ZM19.0746 4.74118H16.1873V19.8685H19.0746V4.74118Z",
    fill: "#6F7687"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.494476,
    y: 19.8684,
    width: 21.3333,
    height: 1.79835,
    fill: "#6F7687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97458 0.333328C6.42229 0.333328 5.97458 0.781042 5.97458 1.33333V20.3846C5.97458 20.9369 6.42229 21.3846 6.97458 21.3846H15.4006C15.9529 21.3846 16.4006 20.9369 16.4006 20.3846V1.33333C16.4006 0.781043 15.9529 0.333328 15.4006 0.333328H6.97458ZM9.26798 3.00001H7.50798V6.44H9.26798V3.00001ZM10.2545 3.00001H12.0145V6.44H10.2545V3.00001ZM14.761 3.00001H13.001V6.44H14.761V3.00001ZM7.53435 8.62662H9.29435V12.0666H7.53435V8.62662ZM12.0409 8.62662H10.2809V12.0666H12.0409V8.62662ZM13.0274 8.62662H14.7874V12.0666H13.0274V8.62662ZM13.5663 14.0502H8.75427V19.8331H13.5663V14.0502Z",
    fill: "#6F7687"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88074,
    y: 6.43999,
    width: 1.30667,
    height: 3.25333,
    fill: "#6F7687"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88074,
    y: 11.72,
    width: 1.30667,
    height: 3.25333,
    fill: "#6F7687"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0009,
    y: 6.43999,
    width: 1.30667,
    height: 3.25333,
    fill: "#6F7687"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0009,
    y: 11.72,
    width: 1.30667,
    height: 3.25333,
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns2IconCompanies);
export default __webpack_public_path__ + "static/media/ins2-icon-companies.8ed59363fc52970c12c4023b1f123eed.svg";
export { ForwardRef as ReactComponent };